// Momenta Studios — Project data.
// Photos remain on Google Drive (read-only thumbnails). Videos are served
// by Bunny Stream (library 659601) — each `videos` entry is a Bunny GUID.
// Bunny's iframe player handles thumbnails, playback, fullscreen.

export const driveThumb = (id, w = 1600) =>
  `https://drive.google.com/thumbnail?id=${id}&sz=w${w}`;

export const drivePreview = (id) =>
  `https://drive.google.com/file/d/${id}/preview`;

export const BUNNY_LIBRARY_ID = "659601";

// Bunny Stream embed URL. Pass `autoplay=true` when opening in lightbox/inline
// playback, `false` when used as a paused preview. `loop` defaults to false
// because most films are full ads; the hero passes `loop=true` for seamless
// background playback.
export const bunnyEmbed = (id, { autoplay = false, muted = true, loop = false } = {}) =>
  `https://player.mediadelivery.net/embed/${BUNNY_LIBRARY_ID}/${id}?autoplay=${autoplay}&loop=${loop}&muted=${muted}&preload=true&responsive=true`;

// Bunny Stream auto-generated thumbnail URL.
export const bunnyThumb = (id) =>
  `https://vz-3a9e9fa1-1a3.b-cdn.net/${id}/thumbnail.jpg`;

// Convenience helpers — kept exported because legacy code paths still reference them.
export const portraitVideoIds = new Set();
export const videoThumbnailOverrides = {};

// ===== FOOD =====
const food = {
  id: "food",
  index: "01",
  title: "Food",
  tagline: "Edible sculpture, plated in light.",
  description:
    "Culinary narratives for restaurants, menus and editorial. Plates, products, and provenance.",
  coverId: "1G32UI2qwaPGBPDmobpqQc6gYOyphZ2tp",
  projects: [
    { id: "waarsa", name: "Waarsa",
      photos: ["1i-pSPznxd6bou0adsFYX4qkOKlrUJPmb","1G32UI2qwaPGBPDmobpqQc6gYOyphZ2tp","1La6dLcgLGbcHllhsNxFBmRw7O4e2N7Ke","1vM3acUXAtzuPlnyjpBWEPUe0em8l1NsT","1dTPsKc10GR_EVX4GAhbaU3IRrEJjc2_4","1-7ZYMAH68z0mx2lJCy-k6doUaVa9Q3eJ","1d73uGrkLLzRsSVeChFpRTq8L6Beb_Te0","1V6mg-_1lG41I0qqaiPaim7Sthkx6SJP9","15MR8hWk9u0LMZuCj0vcDiXac_PqkaUwD","1OtQ9KYaoYsAovkEzpE3EMP5XIgZl9dPY","1hgeCAyhFy4X2xYyRCMmnJtAj9ZUNs2GR","1-OpSP28_SYOswwGJUFbxBugJA4CmNQmG","1SrkoIuSa-c0T9jKTZkPYssHcUedicXnr","19CgHKT8nowBBgQ_FzUYKbxzrj89il2Rm","11G3krw8NabLuN33EJgVLpJQ4UKQPx7DL","1yJvJXXkDnA55gVtuCGSdJi3D0NMMCWT5","1zooEl3GAuhWQIp8ODIApnk8IxQH8kyXS","1bMVRoAQT6Qo181UsXVopQRwVnCRdz6pS","17pmaW5K4tg-pll33X9kt2kHvK5NZAxiz","1VFjTvr9UiqNhlRWPcQ9qvBeqyl15ZF76","1g90HmO6Sg15LbmefqtMm9yHPc5rCMR-k","1M7fFSHQNgei0lHLPt8jMjXKY5keXRrNV","11yqB_jvNOzHhynmFU0yJNEHpOxVmzWFq","1jIFRgAFN9H_x30TPpXDfIQJXJI9IhntA"],
      videos: [
        "ac4024df-a384-47ae-a883-d8d4f71a9b68",
        "9d0dc998-7457-4df2-b8e5-d46c18df38ec",
        "35367d7a-c861-4036-b63d-9adfe59d0d95",
        "6590af4b-74ee-41d9-8bd2-4ad1e10942bb",
        "d8593f34-834f-419a-86c1-b323a1f0e6ec",
        "9e3b3a1a-cba8-4abc-949d-f50fe962e486",
      ],
    },
    { id: "creamstone", name: "Creamstone",
      photos: ["1-0uj3Y6sE9tvtWvZaXPuIFhBD5h3VkSG","1L744rQhXMKabYdJDpZYmSEIXlOGU3KLr","1QlF_k9donKuE4NnNbb-lbfeUZIkt8SzX","1QtVL8Y6LMopNFA84Wyi9OTBoTnAwfkm4","1VJzuuteteOhn_QU2mKG7d3oeyZXUEFpi","1YvYtbaFJvav-Mv11qYRE1qUd3U3nVo1D","1dP6XwnFVVAf4aITzu65a4__NjqwQr3wn","1uXt_dT-R-ELRbdHLb88tpsP4zWlUCPdh","1vy6scrM6xrDAkfqXRSuxyf0tfnBopvyp"],
      videos: [],
    },
    { id: "meetup-points-momos", name: "Meetup Points Momos",
      photos: ["1Bk_miY9k-TM6xmPFVkZBAkjpOWVFlLJv","1c0URRQUlfT2rPE4vvNYQXdztP8bql0ha","1AjAuwgSv1Ml_baZVc2em-pdvUaG8rUdI","1w5izCxdQSn-eLTKRZJpw8Jje9w-Ku2Wp","1Wh8xesfO5oRLnLVt8Er3Hddm_aZmscBn","1HVYLlJVTFEk04EEFo52-OvrIuS6L0MLp","1GngqK7xZi8kXD2BsGR9f1zjgVQSaapi5","14-ud7uIURxowkSiD8xmBlF9hl6lsXS1g","1ykE8H5XZxqWBWiGLHNVBkCIxE0EB6MWT"],
      videos: [],
    },
    {
      id: "aqeeq-haraz-bunn",
      name: "Aqeeq Haraz Bunn",
      photos: ["16OJVdBCjbZn6SkC2kLz1jS49iP5vX19i","17cn8dfYGSgE3aZZSXp8_WbhRlRT4Iyys","1NEUAu9SP6dwJWvcoqOezkbG4LPmYj1mx","1RtcGtNgoN_NaS4xkchLaojnGjQyx8Dah","1SGcmHb1nteMwTtYgDqkFBEE00v60GROR","1bsyOekQgTOH64iu31lsodnJ2o6Gv1Dft","1dYUIouKX6ptDYTRI37Y-TmhLi_8AsW8a","1hlEiMhvQjN2kc-TDFT20RAIMxI4PhEc1","1pilhyDgp0hLpEeeZNa7GWay7NNxvgTiZ"],
      videos: [
        "0e5ee6e0-31d4-447d-a6a7-167dcd5d3584",
        "fae02507-01ec-49eb-b6ee-cbd964fa6569",
        "a2aa4922-5482-4b23-910d-006377835102",
        "7833732f-5b37-42dc-8932-382683c5d307",
      ],
    },
    { id: "sangeeta-sweets", name: "Sangeeta Sweets",
      photos: ["1M1KtKjCQyQ24h-bw53n3mPSDddEzn2Fe","1V10-DAvNVpfAYTGgYrSOPaha6CLpNNxO","1CWomtAiVV37-7uuYlJQeZJYiCYd5ljB9","1658QbeaK366GybHKFGKjGUYzlaVLH_3e","14zQ16MJyuTL30OPY8G6VLsgWU8Ls4mWN","1Q3nI5xW8jjk4CPZqiDr_z2Qf2z93YFRZ","10R6Ly7lr-DCm1ZHHoQwqrUe5lxgFAriH","1ddcXTHAf_dRkn8nj2lkvteWzwQ3oY_Qm","1i8rnNbWOVI3JeDrqYxGQCTwxP_yrfFAL","1YpHs2rXzVoAGYf2ZIESPc9MW9w7hyhqg","1wXjZs8JVAuP1EiiU0esrk827p81eKLFp","1izNVj2939euej4tSCafOVjJFTE8k9DJI","1lY0SIjstR50sF8DDuPt0sOulXXPdmRHC","1oE62202pbjVAhdoicx30q8ZWcQsxyOsC","1MiPYZocOLPRJCLGnAsfVvpTho_YdEbiD","1oe5W8NDzdOL-9ojc-BcxlFXZ7_ZoAyMD","197EA8n2sLtyM4QjaVh0GXgWEznRqEeDu","1e1eusVIAtpDj_vV3gVb3GrRJCu22lvDW","1SvbmPEHwGYsf3yXnmg6LWVUFLt0QPt0W"],
      videos: [],
    },
    { id: "nomi", name: "Nomi",
      photos: ["16Ko70bb6bnk9oNsSQiYO70iBG91Zhz8l","13i7oMKrAbLU8QdMZ0AsA2tvho6c3Ogm4","1cxj6z3ozFnoiBVZwvNx1BSHS8JSI4XAr","1LGe_6ZYyft84tuq8N25_zUZ5jcSyETkV","1jaWLO0mbe28uer4Q2S9ATmo36lAVdNqB","1IOppwmBjNX_A1OXtVhi5vdcFZfULggkM","1RxFxIGwqYbvhUe8MDWlvQKSdPWy5K0Y1","1COYG1O_98EWW3O1LN0_zmXEsuWYTcNh0","1CZ3TcnzNIF7YTE6aeHNylOU-0wdgzo_s","1e0UGL1FkWEsydUMjcUERYYIGkwrgrnrh","1RBhIRQE5Si6-umrsNpULIOFV5f3dxGHB","19joGFLgfLvI3k7Gbxjln8M_a5Gw5bkkv"],
      videos: [],
    },
    { id: "himalayan-chocolates", name: "The Himalayan Chocolates",
      photos: ["1uBE0NOIbBKTpq1kaFCbhonxpJwhIUuRW","14B6ps4wgqdQz120ZdwqBksT35xhTFF1X","10XqM6k-Q5t0HBnNZzXHODtfDEVIonpX7","1SOX63DGfYGYV4yLonzv_VbG3zjwNvdjQ","1RR5F_aY0uCoOZ1XyCGYkFz82Ex8RDKtT","1d_qSbg8PEaOEGkfTVR1JmXGuTX9VBFri","145EjdnVJprhgo_MOVLa3kM-yGuUiwCWR","1nclUIlqDChI9Sa0KOIo7gnd_jEkHbSdx"],
      videos: [],
    },
  ],
};

// ===== PRODUCTS =====
const products = {
  id: "products",
  index: "02",
  title: "Products",
  tagline: "Still life for objects of desire.",
  description:
    "Luxury product stories across fragrance, fashion, home, beauty, travel. Sculpted in shadow and sheen.",
  projects: [
    { id: "al-haq", name: "Al Haq",
      photos: ["1tozk9TiN0TegkNJP1G-5fS6jIHqoSqjb","1cadQP-0guIZDuMst0Oznf28YGxvZUGZn","1m0BNFvbAagSoeRpZF85i6ACyZOq3pK-D","1UyuJyYM3-izOqUpnfsXAkprworHGDAtH","1j-AG7vVRXYP74sItFrZSskxuxGDjo-aG","1zeXNQxUVzDUinboiv4upoWlumw6EiOa7","1I4Ru8dN_coeagOHZFW6kTi7Cee0Pj_wb","1Hai1yyUmHuKyDRnridURzRz2vMgRRdBS","1uVhIL-6-nx2iR67XaMwK66NYN7h6Q4ny","1ZQ_R1t0hb1I8U7rDmmp6w0pFRWlAQqK7","1UgVpkgK_tcr4YHWBLS03Jf23kzWyDGE7","16T48ddH1aLnmO90ockXbDD4as1I6RmOm","1EN4dZnDeO5_hmYDmpEXKzNscLcCB3Ga3","17iH7igoXFZwAQn0-h3P5iaCmkUy37VLe","139onjZ1qLzRpXseYlUw-mCgUpOMnPXYZ","18UlezCdwte-xIgwVpWiX5WsKkj60jdb_","1kE_zdIL1GU1iAhfGnRlTJPMyrK5a5NsD","17Wu5cglllr063GNh3WmaexE6twQbRFYq","1dVjFDCx-2xGfP3dXbkGnIoWcd_9REAUC","1cZOpXgweSx7gltc-BlKniaY6UZi7qOgZ","1CheZc7NPs1nlpwWw_UQ5GZyY_FfeX6b9","1YbfYX0BqWEOBdVurQxKqlyfSdePhrVh7","149vr7Cd2ej6YymmqhI3mfrNNgF0jUUqV","1cc73QPhHk2e7X9Ui_eBBU0TyfXdIa5vW","1xrfRc1zcaIz_Mr7UgRIsZrPOzBh-QtgV","1hEsl04sg3Yg6YAyjMPxDHBld7P_UKzVe","1Gg150RIpl7gGzoE_gblbz6OxS_vw67A7","1ZK1S4G3svgVNuXO-eBMphQuQ0DvF0KVD"],
      videos: [
        "a504465a-92ee-4f91-bc59-9a256a358b0b",
        "01ae6090-393b-4e68-9a6a-a20367c356a3",
        "3e99b6b4-2954-473c-8f30-e6958410f27f",
        "4b46e3b1-60cf-4b93-8178-084798e7a0b7",
        "e7b02e97-5788-4e39-8680-272407102e96",
        "787d70f4-c87a-4d06-b099-54937f0379bb",
      ],
    },
    { id: "vip-bags", name: "VIP Bags",
      photos: ["1H_90_rzPRDsx1I81xxvPzyaxne9-nlPz","11WmS-ZhIee51hS--FfdEFc15JoiTJJrT","1D1MzOe89uuKXUpeFsr7bCiZ-qgtepyWh","11oQxeITnYI6tv2aGfwGlAaOSR4g3v-rK","1eSIbSQ_izHhyObR_1a5iuLop3vXXUO0x","1gcbnEHOLRdpDZTC8tgDsW0NC4gKv3YVP","1OXf1xTbuhQBknzn9FU6RYwCxcn5jOORc","1t0yYfSJgIG-fYpuZc4bwNCSeXqBNOrX0","1R0lghE-N8K-p_z9cCSTGQiWQXJefKivo","1LvDofHfUgFt2Xac864kWIWPx_i9ZVlhX","1jflqVRj0Dvhlpqw2BpLsmKF1EJzJfYo3","1Aw2mvhY9u9I80AmvpxLi6Tda6-2BMmy9","1-TXEJWR4QOHUSF4folF0ML9Ck0G5SNJq","1kuv3UrlhB7KWTKbyYqZSWp2p1gArx2qf","1n3C9W6oCNcSqEdIKhpZrGOjLMjSwqfWC","12SQ0c3w2mUKX9FX3GBWJ4G9rCLuG33bZ","1P3d4kiBtaNX5yhxB-KpJJH8pvW53Ffrd","1ykIEZtDS1zohdzO4W4PJrRDXkTGPHoN9","173e5P-7a7tFrhDT9f97GNdtD1I7rj3jf","1p8Hpm9d_M85emK5OeDkLTVogNp4Ptg-7","1hc2T6G_10RYxMov1pCVgU4RTLALTUbHE","17to5PGE0CePgDOLFpIc2ucTcGy9IAuXR","12zTIxxR1L2rA2FjUr6omuWmkvb9UJqSW","1mos9lFCDt55NfXnhDaYd1BJjmeWM6O4T","15mA5WFc3wdiIbNkFf3puW6wYmjhDvacc","1dr8ze06Lzkdgf0hjppqcCnYx7NCUOALQ","1gsY2M1RwrYywhYTA9RT6klV3-3R5bitt","1D-7CTXxA9lSe_ZeTurawrNhp6pULRuIl","1B1_hIT4BLLA1tjB5-ahatBe7DlC_pOxa","1glVI0ycwMv4nvaiJ7VtudIN0XTdQmr-2"],
      videos: [],
    },
    { id: "bombay-store", name: "The Bombay Store",
      photos: ["1raJ4jBBO6EggZgIAsYjUv72MYxeYnxQ3","1ZUB-QpqME2HgVG2wkbT_-GXr3XObAnOK","1wM0tZ3AXINZmeqBXSOqReaAcZvIUlrHt","1sXi7efwppQDXyNDXJCiK6lH-wZdjrQZI","1nSdIQNyzcR5NAYdsQg-0MCpbz4wqJU5z","1Xm0Ny4u_9tZXsig8lc5XVz2SSuezyenh","15q73pZt0eE_P1SZqpmC_xBiuUVzoAPJM","1KKjsaz_Hj6pCgNqMEapbT9xSNHk3RyZa","1pHJVIHQNWhNq8PoYGodLXotlm5QHrdTh","1--dgWq-CvvPI79YIHpNgIxkOvj_FlwiZ","1Htzc3aoBYNkYwlJlJyJlVc4JetzXDQvv","1ZDiiKAJP60UeEY7OEFyM5wDpeFiyPDKo","1z9sBgPBU-9R8eJj7FVmyIpca38gAfVgv","1d45KRF9W6xPllEcctnGg_17ZEoo9Qxhy","1N7izBKJEXRcMsT5cWvppBRFItTSPfc4J","1UuSy-SGKNPHJB3D6u3dgPZSY4iYWUZ42","1xiFB_E4RlnjH9GDbkf-tXRl5bAIcmGTf","18CaZ4qzEneunCUL9zywCMRadO_PtFYPq","10dVGolvlFMALmWBXAum-TQhbTAH_Ig11","1CaHP84Sf1dYe9DN65ALXEraGLZyBWyOn","1niu0dnUqCaIpJj8o--3u4qsm9AUEqbxf"],
      videos: [],
    },
    { id: "sn-home-decor", name: "SN Home Decor",
      photos: ["19_V7GwmVLIcNbTXa4pI_mWo-d45m7-Au","1uMsUOCXOaNmtzSQsXXlWGTxl8ZP99siT","10Z70EafbVUh8rjPOtmk3oZjCJRWhQ1xq","1yx8mU5-BSCfZDVmzST7HqS25H_GemycP","1N_ELevJaW_1EtoXeT_U59I9MdxRxk7jK","1BHAgooTpRswTbIVEHu2B872if9u7f13Q","1tOM_1F_zHyeYtY673Q-TvuHCmbQM2uDw","1DECp43LI9DjnnQnaiyWPMwfQnsEbeKwi","1IkmBxjzFqkCKgIB-Eq3ndol1js3erDiL","1AzJjxGaWIXJ412zB1-lgNtIDwOXX2VWp","1pOxwAeK8HFpkXDiEMud6vz6LZ2GvnVk7","1T0AwrEuz1I0n-ymDqZhk6dxDInwAuP1v","1C8iMv7vByDqFkMBkur8M3oSQE2oBmNQx","1KZaNJG0AT5EOU96kMrVmUnmn9t4KuawQ","1X0kAZ0DpmDwQF2Xn8qDQdI2AUQ7mw_Uw"],
      videos: [
        "d9f45aaf-f5d4-480e-874d-4a63593ceda0",
        "c0bb3574-a389-42ab-80e2-8c76ace6128a",
        "2e89025d-d14b-4f9c-9afb-4863ea462e49",
        "81a5ff5e-54a6-4298-991e-ac8ee2904d2d",
        "3c5ce8a6-56e9-4161-a613-da3233823829",
        "9199e71f-db97-483f-8b76-0f66c3e47596",
        "f7626db2-7052-4681-8f62-1838f096e5dd",
        "0fec8061-05e2-4360-9b25-1e1fb59d74b4",
        "935cdf8f-9934-4a8c-981b-0ffb9b321410",
        "97c354c7-15fd-407a-9a77-b2e90848dd8d",
      ],
    },
    { id: "dot-key", name: "Dot & Key",
      photos: ["1s4hFYRSpaqaFWp6l2sI1YjZkFxBkqZws","1xBf0i1yOI-NBtSJmy3EU33rsZbC1Si5_","1j4ucOQANiIASOpTSL7TKtC56b3j8gOVR","1i5XZmIB1S3xN_hzR-UG_IELc9EU0NCpb","11Uxo9WghFxtgqi6zczs_4nxS_Nb9jcXW","1MNxul7oFfLGerZD9iltSEFI7WCMwBDiX","10wfO0f6CA6RC9XjMcMgaRt8FANqnhMRN","1gZxrakSK2aPh3Z4aARDJxZLlbIvqxIKe"],
      videos: [],
    },
    { id: "misk-perfumes", name: "Misk Perfumes",
      photos: ["1Yul3ZoqFBl-7oRuAJsny8RpJlnwg0PB-","1cUOD7gdIUwwMN75jT0ebRk-t8AEzRcuU","163VfRvLeQTRrtNM2KyTcQuPKNKukwDqj","1fGPYo3JjS-YnQTjd4H23m3z330OYFygy","1FXYNxI1MnGpJrPgwFOHEt5rMjh67a-HY","1SQ-VYoV3GJJeB0O1lL7ri4B_jvbE6iK2","17ZbzRIZmxfgoeHAI6VTiIbfBgpWIfRsK"],
      videos: [],
    },
    { id: "box-it", name: "Box It",
      photos: ["17QBark2mtc3N6Vde5te_hnXDmzRN-o1K","1xrNjDupgIm_VxF3BGyDJ5c9aQNbQNvQz","1T5HNQFXgpJt7Qvk_eHauAOWoBWdIb34u","1TImJhZEsdoRlwlnTE9I-oOHjDEABOSl6","1RAmtC0Vp6pxIMQnhH39qipK46Q9GexkN","1ycMaoqYF7KMIufxeLFXqN3JupvDNKl6n"],
      videos: ["055999c1-78cd-4282-a7a4-9e4400c2315f"],
    },
  ],
};

// ===== EVENTS =====
const events = {
  id: "events",
  index: "03",
  title: "Events",
  tagline: "Atmospheres, preserved.",
  description:
    "Live coverage for book signings, concerts, film premieres. Energy translated into frames.",
  projects: [
    { id: "warner-bros-premiere", name: "Warner Bros, Film Premiere",
      photos: [], videos: [
        "8bc25ee2-eeb0-4ebf-8834-7ea82c47b5cb",
        "0c711cb4-dddf-4be3-a322-a998620ab5dd",
        "79b078e5-1d9c-4e4b-afd9-b6f5f51b20f4",
      ] },
    { id: "saifee-burhani-expo", name: "Saifee Burhani Expo",
      photos: [], videos: [
        "d3017287-79d6-49bb-97a3-29cc1cae8301",
        "5e004fab-f43c-4bc1-8a46-8129cfe797b9",
        "28847c0f-658f-4bb2-98dc-d503de2e9224",
        "59f0c5db-a381-475b-b192-168d26759d45",
      ] },
    { id: "author-book-signing", name: "Author Book Signing",
      photos: [], videos: [
        "2f06dfc6-ba52-4a79-940b-2d23af4cc714",
        "c4350580-c029-4ce8-ad24-c6bbd6874efe",
      ] },
  ],
};

// ===== CORPORATE FILMS =====
const corporateFilms = {
  id: "corporate-films",
  index: "04",
  title: "Corporate Films",
  tagline: "The craft, in-house.",
  description:
    "Brand films and corporate narratives for companies who lead their category.",
  projects: [
    { id: "acxiom", name: "Acxiom", photos: [], videos: ["4f1709d8-5fbc-4f80-baed-6a4e02b801ed"] },
    { id: "b-tali", name: "B Tali", photos: [], videos: ["19fa4fa1-add3-4eb5-8f4b-59e2fb37047d"] },
    { id: "carbiforce", name: "Carbiforce",
      photos: ["1uQnJKhrKBfHmOwT0kG_Jw8xr8MnUQwlT","1mLnZn97mIJ1-ereXS3c0ISpcyrVXo0Ju","1eF65hd2e0YebWmTSqhQ1htndMX65PJoq","17z1tEsiJjRwTCRebGVNEOJWJkPTDOzro","1IGT9ep7JDEK4hdmOBYZ94P8uBwg_TGpi","19rNto6p3fZ4XIbHYuNW-JgRRB5dWxj28","1w9zyf1vOBLzGYXbSqHP9JDynUawxzu3J","1i4t37HdiByCuVcJq2reHoryesgC5Bh7h","1M76hv492jk9yjoCeUt2kmqf3OofkE9gt","1Nb4nG_UiQcxoompaNrgxnp-4J4GccUij","1pva96TBxxS2pntAU2Wb_Zr6nQP5oaoCA","1wjx7KjuLac0CbK4EJ34GFKqwANI4ZxIw","1KGW5-MWOga0_KTTxv8PUTJdp5ukXeiA_","1hqE_2hF-zg8GCuvtCE5Rpb3vgNu-w47x","1ksdqgbUnv62TN8kxU-6_W7ZEbNZS2Nj-"],
      videos: ["aab3e09a-e0cf-4411-b245-01d065a33d4e"] },
  ],
};

// ===== AD FILMS (dedicated /films page) =====
const adFilms = {
  id: "ad-films",
  index: "00",
  title: "Ad Films",
  tagline: "Full-crew cinema.",
  description: "Commercials and brand films produced with a full Momenta crew.",
  projects: [
    { id: "bags-n-bags", name: "Bags n Bags", photos: [], videos: [
      "be070136-f345-4466-bb91-ba2bf095a724",
      "d098f8d7-c04d-4a78-b358-5f1dd46e5677",
      "a85014d9-bd74-4049-8a29-2598d9793428",
      "5ebf32f3-0441-4910-a819-bd5015794ffd",
      "1077a500-e3d6-48c3-b558-4c462fbc1cb1",
      "f04c0095-57a8-46ce-844f-42f1c592e41c",
      "b6343bc4-dfe3-4b14-87c5-aa40936390c9",
    ] },
    { id: "cadbury", name: "Cadbury", photos: [], videos: ["5ac2303e-927f-4767-8c69-99bcba681473"] },
    { id: "nutraj", name: "Nutraj", photos: [], videos: ["a8b94581-9d62-4d0c-bfc8-63d0c37f4d37"] },
    { id: "sol-de-janeiro", name: "Sol De Janeiro", photos: [], videos: ["8e932293-f31f-4372-8442-59352bfcd943"] },
    { id: "samsung-watch-bts", name: "Samsung Watch BTS", photos: [], videos: ["285ae6f4-74f2-40b5-aa2d-cb039611df0b"] },
    { id: "al-tijaarat", name: "Al-Tijaarat al-Raabehah", photos: [], videos: ["0aa32cfb-def6-4467-a905-2fc45130c717"] },
  ],
};

// Attach a cover thumbnail: client-supplied Drive ID -> Bunny thumbnail of
// the project's first film -> first photo -> stock fallback.
const fallbackCovers = {
  food: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1600&q=85",
  products: "https://images.unsplash.com/photo-1625139109729-3611f838306d?w=1600&q=85",
  events: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=1600&q=85",
  "corporate-films": "https://images.pexels.com/photos/30697923/pexels-photo-30697923.jpeg?auto=compress&w=1600",
  "ad-films": "https://images.pexels.com/photos/30697923/pexels-photo-30697923.jpeg?auto=compress&w=1600",
};

const attachCover = (cat) => {
  let cover = null;
  if (cat.id === "food") cover = driveThumb("1G32UI2qwaPGBPDmobpqQc6gYOyphZ2tp", 2000);
  if (cat.id === "products") cover = driveThumb("1xrfRc1zcaIz_Mr7UgRIsZrPOzBh-QtgV", 2000);
  if (cat.id === "events") cover = driveThumb("1uSZ9f_NgDdDO14oEjYxrirLHpO4tNTOF", 2000);
  if (cat.id === "corporate-films") cover = driveThumb("1k1N0mUYlhoafrRDn1aMy6LLmZyuAUvfT", 2000);
  if (cat.id === "ad-films") cover = bunnyThumb("be070136-f345-4466-bb91-ba2bf095a724"); // Bags n Bags 01

  if (!cover) {
    const p = cat.projects.find((x) => x.photos.length || x.videos.length);
    if (p) {
      if (p.photos[0]) cover = driveThumb(p.photos[0], 2000);
      else if (p.videos[0]) cover = bunnyThumb(p.videos[0]);
    }
  }
  return { ...cat, cover: cover || fallbackCovers[cat.id] };
};

export const categories = [food, products, events, corporateFilms, adFilms].map(attachCover);

export const bts = [
  "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=1800&q=85",
  "https://images.unsplash.com/photo-1524712245354-2c4e5e7121c0?w=1800&q=85",
  "https://images.unsplash.com/photo-1540655037529-dec987208707?w=1800&q=85",
  "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1800&q=85",
  "https://images.unsplash.com/photo-1500210600-fec15b2e2cc1?w=1800&q=85",
  "https://images.unsplash.com/photo-1596807995197-e8e64154a30c?w=1800&q=85",
];

export const clients = [
  "Aqeeq Haraz Bunn","Creamstone","Nomi","Sangeeta Sweets","The Himalayan Chocolates","Waarsa",
  "Al Haq","The Bombay Store","Dot & Key","Misk Perfumes","VIP Bags","SN Home Decor","Box It",
  "Carbiforce","Acxiom","B Tali","Cadbury","Nutraj","Sol De Janeiro","Samsung","Warner Bros",
];

// Client logo image IDs (uploaded by client to Google Drive). If any
// file gets removed from Drive on the client side, the React tile
// auto-hides via onError so the marquee stays clean. Rendered
// transparent on the editorial black canvas.
export const clientLogoIds = [
  "1882rAQnsAfkBSwgbNAq_cBaviHDxr835",
  "1D_pgzJSiIPd73UT06IDw8xe5OByiXFMg",
  "1FlemI4wyh-UdH-118CC5Ofng-nf5c2Rz",
  "1IGGJr2nBMUMQTSgh80gIe22NNbxYyfri",
  "1Xjy9W7gD8fQOY0XOpzp-kR7O8HCQTRLw",
  "1ZKC4No7LZbGaa-pGFGiMQwUFNdKGZc8h",
  "1aZwoSBrrv58g5_0VQgVw8mCX2oVjrUSk",
  "1cEM80MIjaJJ_0w5WnLTRgxW0Qc0tO7e5",
  "1eq1Y-Il-xc39o_nB4OE1KgW83xQDKK5-",
  "1jHDqah5iwHrr4sTqLMNpHvSRpe7AulHV",
  "1lNecXOTtzFgPc1XjVZ-TOLDl-W0QrKai",
  "1rC56pqVAD9jzScft9WoOjLJQT9GkqN_3",
  "1hIzKZUj0_Kgd-t_oRwosCMzBjZqmaQtU",
  "1BroBdDvUl4tNgHOMGYK3KT8qp_le_BO5",
  "1A4FMbwXjZ8dbyh-IfelR2gM73GySLgJn",
];

// Showreel Bunny IDs used as a desktop background teaser on the Ad Films page.
export const showreelIds = [
  "be070136-f345-4466-bb91-ba2bf095a724", // Bags n Bags 01
  "5ac2303e-927f-4767-8c69-99bcba681473", // Cadbury
  "a8b94581-9d62-4d0c-bfc8-63d0c37f4d37", // Nutraj
  "8e932293-f31f-4372-8442-59352bfcd943", // Sol De Janeiro
];

export const owner = {
  name: "Qusai Jangbar",
  role: "Director, Founder & Photographer",
  bio:
    "Qusai started Momenta Studios with a simple idea: that every second deserves a story. What began as a one-person studio is now a full-fledge crew making bold, cinematic work for brands that refuse to blend in.",
};

export const team = [
  { name: "Ashutosh Prasad", role: "Director of Photography", photoId: "1PsPx1PsuwyRHvUhzrhI8Lg0JhaF59Eot", objectPosition: "50% 25%" },
  { name: "Aarav Trivedi", role: "Director", photoId: "1WxH_AFg1RXf03-Olv3_QLgTNUqlyZyfX", objectPosition: "50% 25%" },
  { name: "Idris Rangwalla", role: "Production Manager", photoId: "1YTrP_MzFnjE8sqBvd6WhPWbLijOroP0Y", objectPosition: "50% 25%" },
  { name: "Tarun Raj", role: "Photographer", photoId: "1qcEHbnhpE7hsB-TvvSbJDJNdCwIORQuX", objectPosition: "50% 25%" },
  { name: "Khushi Aarekar", role: "Art Director", photoId: "1dSENeW5joLRC7pGB2-qRztGD4QlslTId", objectPosition: "50% 25%" },
  { name: "Akhilesh Saraf", role: "Editor", photoId: "1y3Xf081hdn8gdVANortqIMH_l-0sDS9f", objectPosition: "50% 25%" },
];

export const ownerPhotoId = "16inTKAOnQx-MHZ5ve9FxjN8yqYi7VMdf";
export const ownerObjectPosition = "50% 30%";

// Hero showreel (desktop) — Bunny stream. Mobile-specific version can be
// dropped in here once the mobile cut is uploaded.
export const heroShowreelDesktopId = "33abb77e-2c7c-41e5-9291-69b6f4e6231e";
export const heroShowreelMobileId = "565fa03d-92d2-4585-b99d-35de85c0dc5d";
export const heroShowreelUrl = bunnyEmbed(heroShowreelDesktopId, { autoplay: true, muted: true, loop: true });

// Process / studio image used in the "How we work" section.
export const processImageId = "1qEFmHIQIXyhDlpNxKx_CgQ_I-DKZCpZ7";

export const socials = {
  instagram: "https://instagram.com/_momentastudios",
  whatsapp: "https://wa.me/919137275484",
};

export const contactPhone = "+91 91372 75484";
